const AlertType = Object.freeze({
  DASHBOARD: 'DASHBOARD',
  MENTIONS: 'MENTIONS',
  METRICS: 'METRICS',
  TRIGGERED_ALERT: 'TRIGGERED_ALERT',
  PRO_SEARCH: 'PRO_SEARCH',
  PRO_MENTIONS: 'PRO_MENTIONS',
  PRO_METRICS: 'PRO_METRICS',
  POSTS: 'POSTS'
})
export default AlertType
// RESERVE BELOW
